module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/amenities.svg?48131a47";